(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * Generic timeline manager.
     *
     * Things can be scheduled to be triggered once the players gets to a certain time interval.
     *
     * Used by several plugins.
     *
     * @namespace timeline
     */

    /**
     * @module Messages
     *
     * Adds event to the timeline.
     *
     * @function add_timeline
     * @param {String}   messageKind='add_timeline'
     * @param {Object}   tl
     * @param {Boolean}  tl.once=false            if true, is discarded after first run
     * @param {Boolean}  tl.stopProcessing=false  if true, timeline processing is discarded for the given timestamp
     * @param {Number}   tl.start                 start time, in seconds or 0-1 (if asRatios)
     * @param {Number}   tl.end                   end time,   in seconds or 0-1 (if asRatios)
     * @param {Boolean}  tl.asRatios=false        if true, start and end are interpreted relative to video viewed percentage
     * @param {String}   tl.kind                  either 'subtitle' or 'pub'. subtitle adds/removes subtitles from overlay; pub publishes a message using args param
     * @param {Array}   [tl.args]                 used for kind==='pub'. sends the message given here
     * @param {String}  [uri]                     bag where to store data, if not current...
     */

    /**
     * Remove event from the timeline.
     *
     * @function remove_timeline
     * @param {String} messageKind='remove_timeline'
     * @param {String}   id
     * @param {String}  [uri]  bag where to store data, if not current...
     */

    /**
     * Removes all events starting with the given prefix from the timeline.
     *
     * @function remove_timeline_prefix
     * @param {String}  messageKind='remove_timeline_prefix'
     * @param {String}  idPrefix
     * @param {String} [uri]      bag where to store data, if not current...
     */




    var genId = function(prefix) {
        return prefix + ( ~~(Math.random() * Math.pow(32, 6)) ).toString(32);
    };

    //var arrIndexOf = SAPO.Utility.arrIndexOf;



    var plugin = function(vc, ui, pub, pubD) {
        this._vc = vc;
        this._ui = ui;
        this._pub = pub;
        this._pubD = pubD;

        this._tl = {};
        this._uri        = undefined;
        this._duration   = undefined;

        this._visibleIds = {};

        this._vc.subscribe('add_timeline metadata_changed load remove_timeline remove_timeline_prefix time_updated', undefined, this);
    };

    plugin.prototype = {

        _name: plugin._name = 'timeline',

        on_add_timeline: function(mt, evt, uri) {
            if (!uri || uri !== this._uri) {
                return;// console.log('ignored add_timeline for %s != %s', uri, this._uri);
            }

            if ( !('id' in evt) ) {
                evt.id = genId('tl_');
            }
            //console.log('ADD TIMELINE', evt, uri);
            this._tl[ evt.id ] = evt;
        },

        on_remove_timeline: function(mt, id, uri) {
            if (!uri || uri !== this._uri) { return; }

            delete this._tl[id];
        },

        on_remove_timeline_prefix: function(mt, idPrefix, uri) {
            if (!uri || uri !== this._uri) { return; }

            var bag = this._tl;

            var idsToKill = [];
            for (var id in bag) {
                if (id.indexOf(idPrefix) === 0) { idsToKill.push(id); }
            }
            for (var i = 0, f = idsToKill.length; i < f; ++i) {
                delete bag[ idsToKill[i] ];
            }
        },

        on_metadata_changed: function(mt, md) {
            this._duration = md.duration;
            //console.log('timeline duration: ', this._duration);
        },

        on_load: function(mt, o) {
            //console.log('timeline load: ', o.requestURL);
            this._uri    = o.requestURL;
            this._isLive = o.isLive;
            this._tl = {};
            //console.log('timeline reset');
        },

        on_time_updated: function(mt, t) {
            /*jshint maxcomplexity: 20 */

            if (this._isLive || isNaN(this._duration)) { return; }

            var t2 = t / this._duration;
            var bag = this._tl;
            var z, el, id, isVisible, weAreBefore, weAreInside, weAreAfter, idsToKill = [];


            //var calledThisFrame = [];


            for (id in bag) {
                if (!bag.hasOwnProperty(id)) { continue; }

                el = bag[id];
                isVisible = id in this._visibleIds;

                if ('asRatios' in el) {
                    weAreBefore = t2 < el.start;
                    weAreAfter  = 'end' in el ? t2 > el.end : !weAreBefore;
                }
                else {
                    weAreBefore = t < el.start;
                    weAreAfter  = 'end' in el ? t > el.end : !weAreBefore;
                }
                weAreInside = !(weAreBefore || weAreAfter);

                //console.log('BAG: ', el, isVisible, weAreBefore, weAreInside, weAreAfter);


                // does things to timeline events
                if (el.kind === 'subtitle') {
                    if (!isVisible && weAreInside) {
                        this._visibleIds[id] = true;
                        this._pub('add_overlay', el);
                    }
                    else if (isVisible && !weAreInside) {
                        delete this._visibleIds[id];
                        this._pub('remove_overlay', id);
                    }
                }
                else if (weAreInside) { // pub & pubs -> publishes either 1 or multiple messages!
                    if (el.kind === 'pub') {
                        this._pub.apply(this._vc, el.args);
                    }
                    else if (el.kind === 'pubs') {
                        for (z = el.args.length - 1; z >= 0; --z) {
                            this._pub.apply(this._vc, el.args[z]);
                        }
                    }
                }

                // queue for killing
                if (weAreInside && 'once' in el) {
                    idsToKill.push(el.id);
                }

                if (weAreInside && 'stopProcessing' in el) {
                    break;
                }
            }

            // kills timeline events
            if (idsToKill.length > 0) {
                for (var i = 0, f = idsToKill.length; i < f; ++i) {
                    delete bag[ idsToKill[i] ];
                }
            }
        }

    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
